import { apiClient } from './axios';

import type {
  CampaignDetail,
  CampaignQuery,
  CreateCampaignDto,
  PaginatedResponse,
  UpdateCampaignDto,
} from '@repo/shared-types';

export const campaignsApi = {
  getCampaigns: async (
    query: Partial<CampaignQuery> = {},
  ): Promise<PaginatedResponse<CampaignDetail>> => {
    const response = await apiClient.get<PaginatedResponse<CampaignDetail>>('/campaigns', {
      params: query,
    });
    return response.data;
  },

  getCampaign: async (id: string): Promise<CampaignDetail> => {
    const response = await apiClient.get<CampaignDetail>(`/campaigns/${id}`);
    return response.data;
  },

  createCampaign: async (data: CreateCampaignDto): Promise<CampaignDetail> => {
    const response = await apiClient.post<CampaignDetail>('/campaigns', data);
    return response.data;
  },

  updateCampaign: async (id: string, data: UpdateCampaignDto): Promise<CampaignDetail> => {
    const response = await apiClient.patch<CampaignDetail>(`/campaigns/${id}`, data);
    return response.data;
  },

  deleteCampaign: async (id: string): Promise<void> => {
    await apiClient.delete(`/campaigns/${id}`);
  },
};
